import { createFileRoute } from '@tanstack/react-router';
import SectionEditPage from '@/features/resume-builder/section-edit';

export const Route = createFileRoute('/modulos/$moduleId_/curriculo/$section/$itemId/editar')({
  component: SectionEditPage,
});
